import { render, staticRenderFns } from "./CoachTeamDetail.vue?vue&type=template&id=99a0f2b2&scoped=true"
import script from "./CoachTeamDetail.vue?vue&type=script&lang=js"
export * from "./CoachTeamDetail.vue?vue&type=script&lang=js"
import style0 from "./CoachTeamDetail.vue?vue&type=style&index=0&id=99a0f2b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99a0f2b2",
  null
  
)

export default component.exports